import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import ErrorMessage from '@/components/error-message/index.vue'
import { translate } from '@/languages/i18n'
import { ERROR_INVALID_PARAMS, ERROR_FORBIDDEN_OPERATION, ERROR_EXPIRED } from '@/constants/messageCode'
import groupsServices from '@/services/groups.service'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()

const invitedCodeNotFound = ref<boolean>(false)
const forbiddenOperation = ref<boolean>(false)
const expiredUrl = ref<boolean>(false)

onMounted(async () => {
  const path = route.path.split('/')[1]
  const params = {
    invited_code: route.params?.key,
  }
  if (route.params?.key) {
    try {
      const invitedGroupRes = await groupsServices.joinInvitedGroupApi(route.params?.id, route.params?.group_id, params)

      if (invitedGroupRes?.response?.status === 400) {
        const errorMessage = invitedGroupRes?.response?.data?.data[0]?.message_code
        switch (errorMessage) {
          case ERROR_INVALID_PARAMS:
            invitedCodeNotFound.value = true
            break
          case ERROR_FORBIDDEN_OPERATION:
            forbiddenOperation.value = true
            break
          case ERROR_EXPIRED:
            expiredUrl.value = true
            break
          default:
            router.push('/404')
        }
      }
      if (invitedGroupRes?.status === 200) {
        router.push(`/${path}/communities/${route.params.id}/groups/${route.params.group_id}/talk_rooms`)
      }
    } catch (error) {
      console.log(error)
    }
  } else {
    router.push('/404')
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (invitedCodeNotFound.value)
      ? (_openBlock(), _createBlock(ErrorMessage, {
          key: 0,
          title: _unref(translate)('invitedGroupUrlNotFound')
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (forbiddenOperation.value)
      ? (_openBlock(), _createBlock(ErrorMessage, {
          key: 1,
          title: _unref(translate)('FORBIDDEN_OPERATION')
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (expiredUrl.value)
      ? (_openBlock(), _createBlock(ErrorMessage, {
          key: 2,
          title: _unref(translate)('expiredUrl')
        }, null, 8, ["title"]))
      : _createCommentVNode("", true)
  ]))
}
}

})